import { useEffect } from 'react';
import { useMatches } from 'react-router';

const APP_NAME = 'NVX';

export function useDocumentTitle() {
  const matches = useMatches();
  const title = [...matches]
    .reverse()
    .find((m) => (m.handle as { title?: string })?.title)
    ?.handle as { title?: string } | undefined;

  useEffect(() => {
    document.title = title?.title
      ? `${title.title} - ${APP_NAME}`
      : APP_NAME;
  }, [title?.title]);
}
